module.exports = __webpack_public_path__ + "static/icons/icon-snow-alert-5f663762e026f85b76b713b77b2238e1.svg";